'use strict';

export const DOWNLOAD_TYPE_OPTIONS = [
	{
		label: 'Standard URL',
		value: 'uri-request'
	},
	{
		label: 'ZIP File',
		value: 'zip'
	},
];

export const PARSE_TYPE_OPTIONS = [
	{
		label: 'ZNCF',
		value: 'zncf'
	},
];



// WEBPACK FOOTER //
// ./src/assets/js/constants/FeedOptions.js